import React from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import EvaluatorService from '../../../Services/EvaluatorService';
import ShownOverWindowsEnum from '../../../Enums/ShownOverWindowsEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ReportRunnerService from '../../../Services/ReportRunnerSerivce';
import ErrorMessage from '../../../Elements/ErrorMessage';
import EmailCampaignExportItem from './EmailCampaignExportItem';
import EvaluatorEmailCampaignExportSearchParams from './EvaluatorEmailCampaignExportSearchParams';

class EvaluatorEmailCampaignExportAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    const searchItem = new EvaluatorEmailCampaignExportSearchParams();

    this.state = {
      shownPanel: ShownPanelsEnum.Search,
      searchItem,
      orderDirection: 'Asc',
      selected: -1,
      selectedEvaluator: null,
      shownOverWindow: ShownOverWindowsEnum.None,
      tipaltiEvaluator: null,
      evaluatorList: [],
      cleared: process.env.NODE_ENV !== 'development',
    };
    this.startSearch = this.startSearch.bind(this);
    this.startExport = this.startExport.bind(this);
    this.handleExportOnClick = this.handleExportOnClick.bind(this);
  }

  startSearch(searchItem) {
    this.setState({
      searchItem,
      cleared: false,
    });
  }

  startExport() {
    ReportRunnerService.ExportEmailCampaignReportToExcel(this.state.searchItem).catch(() =>
      ErrorMessage.SetErrorMessage('EECEA45')
    );
    ErrorMessage.SetSuccessWithWait(
      'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.'
    );
  }

  handleExportOnClick() {
    if (this.state.searchItem.IncludeSelfDeactivated === 'true') {
      ErrorMessage.SetApprove(
        <span>
          The search included self-deactivated shoppers.
          <br />
          Are you sure you want to proceed with the export?
        </span>,
        () => this.startExport()
      );
    } else {
      this.startExport();
    }
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={EmailCampaignExportItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={EvaluatorService.GetEmailCampaignExportEvaluators}
          convertDBItemsFunction={EvaluatorService.ConvertDBEvaluator}
          searchParamsType={EvaluatorEmailCampaignExportSearchParams}
          orderDirection={this.state.orderDirection}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          cleared={this.state.cleared}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in different id, name or email...'
          errorCode='EPEA110'
          isExportExcelDisabled={false}
          clickOnExportExcel={this.handleExportOnClick}
        />
      </div>
    );
  }
}

export default EvaluatorEmailCampaignExportAdmin;
